import { GetApp } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import moment from "moment";
import { useMemo, useState } from "react";
import { getFormatoFechaExportacion } from "../../../../utils/datetimeUtils";
import { downloadCsv } from "../../../../utils/filesUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";

const ProviderStatsTable = ({ data, loading, fetchData }) => {

    const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);

    const columns = useMemo(() => [
        {
            header: "ART",
            accessorKey: "art"
        },
        {
            header: "Razón Social",
            accessorKey: "razonSocial",
        },
        {
            header: "CUIT",
            accessorKey: "cuit",
        },
        {
            header: "Tipo Conexión",
            accessorKey: "tipoSistemas",
        },
        {
            header: "Derivaciones",
            accessorKey: "derivaciones",
        },
        {
            header: "Cant. IAMI",
            accessorKey: "cantIAMI",
        },
        {
            header: "Cant. Siniestros IAMI",
            accessorKey: "cantSinIAMI",
        },
        {
            header: "Fecha Último IAMI",
            accessorKey: "fechaUltimoIAMI",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Cant. IET",
            accessorKey: "cantIET",
        },
        {
            header: "Cant. Siniestros IET",
            accessorKey: "cantSinIET",
        },
        {
            header: "Fecha Último IET",
            accessorKey: "fechaUltimoIET",
            enableColumnActions: false,
            filterVariant: 'date',
            filterFn: (row, columnId, filterValue) => {
                if (!filterValue) return true;
                const cellValue = row.getValue(columnId);
                if (!cellValue) return false;
                return moment(cellValue).isSame(filterValue, "day");
            },
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Cant. AM",
            accessorKey: "cantAM",
        },
        {
            header: "Cant. Siniestros AM",
            accessorKey: "cantSinAM",
        },
        {
            header: "Fecha Último AM",
            accessorKey: "fechaUltimoAM",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Cant. FPA",
            accessorKey: "cantFPA",
        },
        {
            header: "Cant. Siniestros FPA",
            accessorKey: "cantSinFPA",
        },
        {
            header: "Fecha Último FPA",
            accessorKey: "fechaUltimoFPA",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Cant. FPT",
            accessorKey: "cantFPT",
        },
        {
            header: "Cant. Siniestros FPT",
            accessorKey: "cantSinFPT",
        },
        {
            header: "Fecha Último FPT",
            accessorKey: "fechaUltimoFPT",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Cant. Adjuntos IAMI",
            accessorKey: "cantAdjuntosIAMI",
        },
        {
            header: "Cant. Siniestros Adjuntos IAMI",
            accessorKey: "cantSinAdjuntosIAMI",
        },
        {
            header: "Cant. Adjuntos IET",
            accessorKey: "cantAdjuntosIET",
        },
        {
            header: "Cant. Siniestros Adjuntos IET",
            accessorKey: "cantSinAdjuntosIET",
        },
        {
            header: "Cant. Adjuntos AM",
            accessorKey: "cantAdjuntosAM",
        },
        {
            header: "Cant. Siniestros Adjuntos AM",
            accessorKey: "cantSinAdjuntosAM",
        },
        {
            header: "Cant. Adjuntos FPA",
            accessorKey: "cantAdjuntosFPA",
        },
        {
            header: "Cant. Siniestros Adjuntos FPA",
            accessorKey: "cantSinAdjuntosFPA",
        },
        {
            header: "Cant. Adjuntos FPT",
            accessorKey: "cantAdjuntosFPT",
        },
        {
            header: "Cant. Siniestros Adjuntos FPT",
            accessorKey: "cantSinAdjuntosFPT",
        },
        {
            header: "Fecha Último Adjunto",
            accessorKey: "fechaUltimoAdjunto",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Cant. Turnos",
            accessorKey: "cantTurnos",
        },
        {
            header: "Cant. Siniestros Turnos",
            accessorKey: "cantSinTurnos",
        },
        {
            header: "Cant. Turnos con Asistencia",
            accessorKey: "cantTurnosConAsistencia",
        },
        {
            header: "Cant. Firmas en Turnos",
            accessorKey: "cantFirmasEnTurnos",
        },
        {
            header: "Último Turno Entregado",
            accessorKey: "ultimoTurnoEntregado",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Primer Carga de Turno",
            accessorKey: "primerCargaDeTurno",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
        {
            header: "Última Carga de Turno",
            accessorKey: "ultimaCargaDeTurno",
            enableColumnActions: false,
            filterVariant: 'date',
            Cell: ({ cell }) => {
                const date = cell.getValue();
                return date ? new Date(date).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                }) : '-';
            }
        },
    ], []);

    const handleExportToCsv = () => {
        setIsDownloadingCsv(true);

        try {
            const encabezado = [
                "ART",
                "Prestador",
                "Código ART Prestador",
                "Razón Social",
                "CUIT",
                "Tipo Sistemas",
                "Derivaciones",
                "Cant. IAMI",
                "Cant. Siniestros IAMI",
                "Fecha Último IAMI",
                "Cant. IET",
                "Cant. Siniestros IET",
                "Fecha Último IET",
                "Cant. AM",
                "Cant. Siniestros AM",
                "Fecha Último AM",
                "Cant. FPA",
                "Cant. Siniestros FPA",
                "Fecha Último FPA",
                "Cant. FPT",
                "Cant. Siniestros FPT",
                "Fecha Último FPT",
                "Cant. Adjuntos IAMI",
                "Cant. Siniestros Adjuntos IAMI",
                "Cant. Adjuntos IET",
                "Cant. Siniestros Adjuntos IET",
                "Cant. Adjuntos AM",
                "Cant. Siniestros Adjuntos AM",
                "Cant. Adjuntos FPA",
                "Cant. Siniestros Adjuntos FPA",
                "Cant. Adjuntos FPT",
                "Cant. Siniestros Adjuntos FPT",
                "Fecha Último Adjunto",
                "Cant. Turnos",
                "Cant. Siniestros Turnos",
                "Cant. Turnos con Asistencia",
                "Cant. Firmas en Turnos",
                "Último Turno Entregado",
                "Primer Carga de Turno",
                "Última Carga de Turno",
            ];

            const formattedDataAsCsv = [
                encabezado,
                ...data.map((fila) => [
                    fila.art || '',
                    fila.prestador || '',
                    fila.codigoARTPrestador || '',
                    fila.razonSocial || '',
                    fila.cuit || '',
                    fila.tipoSistemas || '',
                    fila.derivaciones || 0,
                    fila.cantIAMI || 0,
                    fila.cantSinIAMI || 0,
                    getFormatoFechaExportacion(fila.fechaUltimoIAMI, "P"),
                    fila.cantIET || 0,
                    fila.cantSinIET || 0,
                    getFormatoFechaExportacion(fila.fechaUltimoIET, "P"),
                    fila.cantAM || 0,
                    fila.cantSinAM || 0,
                    getFormatoFechaExportacion(fila.fechaUltimoAM, "P"),
                    fila.cantFPA || 0,
                    fila.cantSinFPA || 0,
                    getFormatoFechaExportacion(fila.fechaUltimoFPA, "P"),
                    fila.cantFPT || 0,
                    fila.cantSinFPT || 0,
                    getFormatoFechaExportacion(fila.fechaUltimoFPT, "P"),
                    fila.cantAdjuntosIAMI || 0,
                    fila.cantSinAdjuntosIAMI || 0,
                    fila.cantAdjuntosIET || 0,
                    fila.cantSinAdjuntosIET || 0,
                    fila.cantAdjuntosAM || 0,
                    fila.cantSinAdjuntosAM || 0,
                    fila.cantAdjuntosFPA || 0,
                    fila.cantSinAdjuntosFPA || 0,
                    fila.cantAdjuntosFPT || 0,
                    fila.cantSinAdjuntosFPT || 0,
                    getFormatoFechaExportacion(fila.fechaUltimoAdjunto, "P"),
                    fila.cantTurnos || 0,
                    fila.cantSinTurnos || 0,
                    fila.cantTurnosConAsistencia || 0,
                    fila.cantFirmasEnTurnos || 0,
                    getFormatoFechaExportacion(fila.ultimoTurnoEntregado, "P"),
                    getFormatoFechaExportacion(fila.primerCargaDeTurno, "P"),
                    getFormatoFechaExportacion(fila.ultimaCargaDeTurno, "P"),
                ]),
            ];

            let csvContent = "sep=,\n";
            csvContent += formattedDataAsCsv.map((e) => e.join(",")).join("\n");

            downloadCsv(csvContent, `estadisticas_proveedores_${moment().format("YYYYMMDD")}`);
            snackbarUtils.success("Las estadísticas han sido descargadas con éxito.");
            setIsDownloadingCsv(false);
        } catch (err) {
            console.error("Error exporting data:", err);
            snackbarUtils.error("Error al exportar los datos");
            setIsDownloadingCsv(false);
        }
    };

    return (
        <div>
            <MaterialReactTable
                {...tableConfig}
                muiTableHeadCellProps={{
                    sx: {
                        ...tableConfig.muiTableHeadCellProps.sx,
                        alignContent: "end"
                    },
                }}
                columns={columns}
                data={data}
                state={{ isLoading: loading || isDownloadingCsv }}
                renderTopToolbarCustomActions={() => (
                    <Box display={"flex"} justifyContent={"space-evenly"}>
                        <TitleContainer
                            title="Estadísticas Prestadores"
                            fetchData={fetchData}
                        />
                        <Tooltip title="Exportar CSV" arrow="top">
                            <IconButton
                                color="inherit"
                                sx={{ margin: 2 }}
                                onClick={handleExportToCsv}>
                                <GetApp />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
            />
        </div>
    );
};

export default ProviderStatsTable;
